const decimalFraction = 100; // rounding to the hundredths place, which is the second place to the right of the decimal point

export const convertToDecimal = (value: number): number =>
	Math.round(value * decimalFraction) / decimalFraction;
